import BaseData from "@/components/POI/BaseData/BaseData.vue";
import POIDescription from "@/components/POI/POIDescription/POIDescription.vue";
import Media from "@/components/POI/Media/Media.vue";
import OpeningHours from "@/components/POI/OpeningHours/OpeningHours.vue";
import Prices from "@/components/POI/Prices/Prices.vue";
import Features from "@/components/POI/Features/Features.vue";
import OnlineLinks from "@/components/POI/OnlineLinks/OnlineLinks.vue";
import LatestNews from "@/components/POI/LatestNews/LatestNews.vue";
import ContactData from "@/components/POI/ContactData/ContactData.vue";
import Connections from "@/components/POI/Connections/Connections.vue";
import License from "@/components/Common/License/License.vue";
import ProcessingStatus from "@/components/POI/ProcessingStatus/ProcessingStatus.vue";
import POISkiState from "@/components/POI/POISkiState/POISkiState.vue";
import POIDestinationState from "@/components/POI/POIDestinationState/POIDestinationState.vue";
import POILiftState from "@/components/POI/POILiftState/POILiftState.vue";
import POILakeState from "@/components/POI/POILakeState/POILakeState.vue";
import POIParkingLotState from "@/components/POI/POIParkingLotState/POIParkingLotState.vue";
import POITrackState from "@/components/POI/POITrackState/POITrackState.vue";
import POITrailState from "@/components/POI/POITrailState/POITrailState.vue";
import POISledgeTrackState from "@/components/POI/POISledgeTrackState/POISledgeTrackState.vue";
import POIHikingState from "@/components/POI/POIHikingState/POIHikingState.vue";
import POIHutsState from "@/components/POI/POIHutsState/POIHutsState.vue";
import POIRoute from "@/components/POI/POIRoute/POIRoute.vue";
import POIGeneralState from "@/components/POI/POIGeneralState/POIGeneralState.vue";
import ExcursionTicker from "@/components/POI/ExcursionTicker/ExcursionTicker.vue";
import PoiExhibition from "@/components/POI/PoiExhibition/PoiExhibition.vue";
import PoiContactPerson from "@/components/POI/PoiContactPerson/PoiContactPerson.vue";
import PoiOploc from "@/components/POI/POIOploc/POIOploc.vue";
import POIConference from "@/components/POI/POIConference/POIConference.vue";
import POIConferenceRooms from "@/components/POI/POIConferenceRooms/POIConferenceRooms.vue";
import POIJobPostings from "@/components/POI/POIJobPostings/POIJobPostings.vue";
import POIGastronomy from "@/components/POI/POIGastronomy/POIGastronomy.vue";
import POICamping from "@/components/POI/POICamping/POICamping.vue";
import POIHighlights from "@/components/POI/POIHighlights/POIHighlights.vue";
import { stateItems } from "@/configuration/formConfigurations";
import Vue from "vue";

export default {
  components: {
    POIJobPostings,
    POIConferenceRooms,
    POIConference,
    PoiOploc,
    PoiContactPerson,
    PoiExhibition,
    BaseData,
    POIDescription,
    Media,
    OpeningHours,
    Prices,
    Features,
    OnlineLinks,
    LatestNews,
    ContactData,
    Connections,
    License,
    ProcessingStatus,
    POISkiState,
    POIDestinationState,
    POILiftState,
    POILakeState,
    POIParkingLotState,
    POITrackState,
    POITrailState,
    POISledgeTrackState,
    POIHikingState,
    POIHutsState,
    POIGeneralState,
    POIRoute,
    ExcursionTicker,
    POIGastronomy,
    POICamping,
    POIHighlights
  },
  props: [
    "errorList",
    "categoryGroups",
    "groupedCategories",
    "categoryTypes",
    "principals",
    "editedItem",
    "onOpen",
    "step",
    "regions",
    "isOwnedBySubPrincipal",
    "validStepsForOwnedBySubPrincipal"
  ],
  data: () => {
    return {
      sharedState: Vue.observable({
        stateItems
      })
    };
  },
  provide() {
    return {
      sharedState: this.sharedState
    };
  },
  methods: {
    isValidStepForOwnedBySubPrincipal(value) {
      if (!this.isOwnedBySubPrincipal) {
        return true;
      }
      return this.validStepsForOwnedBySubPrincipal.includes(value);
    },
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    checkStep(step) {
      const type = this.categoryTypes.find(
        ct => ct._id === this.editedItem?.categoryType
      );

      const group = this.categoryGroups.find(cg => {
        return !!cg?.categories?.find(
          cat => cat._id === this.editedItem.category
        );
      });

      return group?.poiSteps?.includes(step) || type?.poiSteps?.includes(step);
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    hasOplocRights() {
      if (this.isAdmin) {
        return true;
      }
      const eventRolesForOplocCreation = [
        "role:events_admin",
        "role:events_editor"
      ];

      return this.$store.state.currentUser?.scopes.some(scope =>
        eventRolesForOplocCreation.includes(scope)
      );
    }
  }
};
